import * as s from "../ModalTemplateStyled";
import ModalHeader, {
  ModalSubTitleInterface,
} from "components/blocks/modalheader/ModalHeader";
import ModalTemplate from "../ModalTemplate";
type Props = {
  title: string;
  subTitle?: string | ModalSubTitleInterface[];
  children?: React.ReactNode;
  onModal: () => void;
  disableClose?: boolean;
  className?: string;
};

const BigPopupTemplate = ({
  title,
  subTitle,
  children,
  onModal,
  disableClose,
  className = "",
}: Props) => (
  <ModalTemplate>
    <s.Modal
      id={title + "_popup"}
      className={`big-popup-template ${className}`}
    >
      <ModalHeader
        title={title}
        subTitle={subTitle}
        onModal={onModal}
        disableClose={disableClose}
      />
      <s.Inner className="big-popup-template-inner">{children}</s.Inner>
    </s.Modal>
  </ModalTemplate>
);

export default BigPopupTemplate;
